import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../../../utils/getCredentials';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import setRequestCorrectionFiling from '../services/setRequestCorrectionFiling.service';
import { reportUnsentFilingsChange } from './reportUnsentFilingsChange.thunk';

export const requestCorrectionFiling = createAsyncThunk(
  'filings/requestCorrectionFiling',
  async (data, { dispatch, getState }) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const state = getState();

    const projectId = selectSelectedProjectId(state);

    if (!data) {
      return;
    }

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    const createdFiling = await setRequestCorrectionFiling(data, projectId, params);

    dispatch(
      reportUnsentFilingsChange({
        projectId: createdFiling?.project || projectId,
        addedFiling: createdFiling,
      })
    );

    return { createdFiling };
  }
);
